<template>
<div class="lg:flex mainlogo">
			<span class="text-lg font-bold ">
				<img src="@/assets/crystaSureLogo.svg" alt=""  v-if="isSidebarToggle" class="crystaSureLogo"/>
				<img src="@/assets/crystaSureShield.svg" alt="" v-else  class="crystaSureShield"/>

			</span>
		</div>
		<div class="fixed bg-white sidebar flex flex-col justify-between sideheight h-full z-50" :class="{ 'w-40': isSidebarToggle, 'w-10': !isSidebarToggle }">
		<ul>
			<!-- <li v-for="(menu, menuIndex) in menus" :key="menuIndex" @click="navigate(menu.optionName, menu.optionRoute)" class="cursor-pointer hover:bg-white" @mouseover="menu.hover = true" @mouseleave="menu.hover = false">		
				<div :class="selectedOptionName == menu.optionName ? 'bg-white text-black font-bold a' : 'text-lightgrey font-normal'" v-if="userInfo.currentRole == menu.userRole">
					<a class="flex navchild hover:text-black py-1" :class="{ 'pl-1': isSidebarToggle, 'pl-2.5': !isSidebarToggle }">
						<img
							:src="menu.hover || selectedOptionName === menu.optionName ? menu.colouredoptionImage : menu.defaultoptionImage"
							class="icon"
							:class="{ 'px-1.5': isSidebarToggle, '': !isSidebarToggle }"
						/>
						<div class="item-name leading-5 text-sm" :class="selectedOptionName == menu.optionName ? 'text-black font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">{{ menu.displayOptionName }}</div>
					</a>
				</div>
				<div :class="selectedOptionName == menu.optionName ? 'bg-white text-black font-bold a' : 'text-lightgrey font-normal'"  v-if="!menu.hasOwnProperty('userRole')" @mouseover="menu.hover = true" @mouseleave="menu.hover = false">
					<a class="flex navchild hover:text-black py-1" :class="{ 'pl-1': isSidebarToggle, 'pl-2.5': !isSidebarToggle }">
						<img
							:src="menu.hover || selectedOptionName === menu.optionName ? '' : menu.defaultoptionImage"
							class="icon"
							:class="{ 'px-1.5': isSidebarToggle, '': !isSidebarToggle }"
							/>
						<div class="item-name leading-5 text-sm" :class="selectedOptionName == menu.optionName ? 'text-black font-bold' : 'text-listIconColor font-normal'"  v-if="isSidebarToggle">{{ menu.displayOptionName }}</div>
					</a>
				</div>
			</li> -->
			<li 
				@click="navigate('dashboard', 'dashboard')" 
				class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5"
				v-if="userInfo.currentRole == 10207|| userInfo.organisationId=='Global'"
				@mouseenter="sidebar.dashboard = true" 
				@mouseleave="sidebar.dashboard = false"
				:class="selectedOptionName === 'dashboard' ? 'bg-primary text-white font-normal a svg-icon123' : 'text-black font-normal'" 
			>
				<div>
					<a class="flex  controlalign navchild items-center hover:text-white py-1.5">
						<div class="py-0.5">
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="2" y="1" width="6.99971" height="5.24978" rx="1" fill="black"/>
							<rect x="2" y="7.12537" width="6.99971" height="9.6246" rx="1" fill="black"/>
							<rect x="9.87488" y="1" width="6.99971" height="9.6246" rx="1" fill="black"/>
							<rect x="9.87488" y="11.4999" width="6.99971" height="5.24978" rx="1" fill="black"/>
						</svg>
						</div>
						<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'dashboard' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Dashboard</div>
					</a>
				</div>
				<div v-if="sidebar.dashboard && !isSidebarToggle" class="absolute z-50  rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white bg-tooltip">Dashboard</div>
				</div>
			</li>
			<li 
				@click="navigate('course_management', 'course_management')" class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5" @mouseenter="sidebar.course_management = true" @mouseleave="sidebar.course_management = false" :class="selectedOptionName === 'course_management' ? 'bg-primary text-white font-bold a svg-icon123' : 'text-black font-normal'" v-if="userInfo.currentRole == 10207|| userInfo.organisationId=='Global'">
				<div>
					<a class="flex navchild  controlalign items-center hover:text-white py-1.5">
						<div class="py-0.5">
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M2.23385 2.84509C2.31385 2.80571 4.16308 2.45912 6.63077 2.01801C8.97538 1.59659 10.9446 1.25394 11.0062 1.25001C11.1446 1.24607 16.4062 3.26651 16.4708 3.34922C16.5323 3.42799 16.5262 3.59734 16.4585 3.6958C16.4246 3.73913 16.3015 3.83759 16.1815 3.90848C16.04 3.99119 15.9292 4.08965 15.8646 4.18811C15.6831 4.47169 15.5846 5.0979 15.6277 5.70049L15.6492 5.99194L16.0092 6.1416C16.4923 6.34247 16.7354 6.50788 16.7477 6.64967C16.7569 6.74813 16.7446 6.75994 16.5938 6.81508C16.5046 6.84659 16.3262 6.90567 16.2 6.94111C16.0738 6.97656 15.9662 7.01201 15.96 7.01595C15.9538 7.01988 15.9846 7.09078 16.0277 7.17348C16.2215 7.53976 16.3108 8.08721 16.28 8.74888C16.2647 9.07774 16.2253 9.3817 16.1647 9.65047C16.0411 9.41874 15.8998 9.19788 15.7426 8.98971C15.7433 8.98298 15.744 8.97622 15.7446 8.96943C15.8062 8.3314 15.7138 7.73669 15.52 7.52795C15.4492 7.45706 15.3938 7.42949 15.2985 7.43342C15.2571 7.43342 14.9418 7.55239 14.4105 7.76584C13.8413 7.40739 13.1947 7.16057 12.5014 7.05609C13.5011 6.73777 14.3451 6.4712 14.6185 6.38579L15.3262 6.16523L15.2985 5.88166C15.2554 5.44055 15.2892 4.82221 15.3785 4.46381C15.4215 4.29839 15.4462 4.16055 15.4338 4.16448C15.4246 4.16448 13.8585 4.57802 11.9538 5.08215L8.49231 5.99588L8.47385 6.16917C8.46462 6.26763 8.44615 6.79933 8.43385 7.35466L8.41426 8.27532C8.07491 8.57943 7.77737 8.92924 7.5313 9.31506C7.02852 9.18233 6.44758 9.02932 5.83077 8.86703C3.94769 8.37472 2.37846 7.96118 2.34769 7.94937C2.29846 7.93361 2.29846 7.94543 2.35385 8.15023C2.45231 8.51257 2.48615 8.90248 2.46462 9.44599L2.44308 9.94224L5.87692 11.0371C6.19423 11.1378 6.50212 11.2352 6.79485 11.3275C6.76527 11.5474 6.75 11.7719 6.75 12C6.75 12.4211 6.80206 12.83 6.90008 13.2207L4.86154 12.3683C3.33846 11.7342 2.04308 11.2104 1.98462 11.2144C1.65231 11.2144 1.50462 11.6358 1.53231 12.5101C1.55077 13.1363 1.62154 13.4514 1.80923 13.7074L1.93846 13.8886L4.75077 14.8969C6.29538 15.4482 7.56923 15.8933 7.57846 15.8775C7.58969 15.8652 7.60929 15.3518 7.62373 14.8246C7.72408 14.971 7.83202 15.1117 7.94697 15.2462C7.9387 15.6063 7.93515 15.8838 7.94154 15.8933C7.94468 15.8973 8.12659 15.8438 8.43988 15.7475C8.74512 16.0173 9.08358 16.2504 9.44834 16.4399C8.38448 16.7677 7.62189 17 7.6 17C7.49846 17 1.74769 14.5857 1.64308 14.4991C1.40308 14.3021 1.2 13.8807 1.08615 13.349C1.02769 13.0851 1.01846 12.9355 1.01846 12.3132C1.01846 11.6397 1.02154 11.5649 1.08923 11.3483C1.12923 11.2183 1.21538 11.0135 1.28 10.8875L1.39692 10.6669L1.31385 10.6394C1.01231 10.5488 1 10.5409 1 10.4424C1 10.2967 1.21846 10.1392 1.69846 9.94224L2.10154 9.77288L2.12615 9.52082C2.15692 9.16636 2.12308 8.67799 2.04615 8.36685C1.96615 8.02814 1.79385 7.78789 1.55077 7.6658C1.34769 7.56733 1.24 7.43736 1.24 7.29164C1.23692 7.1341 1.29846 7.0829 1.65231 6.94505L1.97846 6.81902L1.90154 6.70087C1.76923 6.49607 1.59077 5.96831 1.53231 5.61778C1.46769 5.2003 1.45846 4.35747 1.52 4.01876C1.61231 3.48313 1.90462 3.00657 2.23385 2.84509ZM16.1682 14.343C16.2027 14.2781 16.2358 14.2123 16.2675 14.1457C16.3123 14.2145 16.3044 14.2732 16.24 14.3179C16.2367 14.3199 16.2121 14.3285 16.1682 14.343ZM8.12615 5.98406C8.12308 5.98012 6.86462 5.45237 5.33231 4.8104C3.68923 4.1251 2.49846 3.64854 2.43077 3.64854C2.33846 3.64854 2.29538 3.67611 2.21538 3.78639C2.05538 4.00301 2 4.26295 2 4.7907C2.00308 5.52326 2.12615 6.02345 2.35385 6.24794C2.44 6.33065 3.00308 6.54727 5.25231 7.35072C6.79077 7.89817 8.05231 8.34321 8.05846 8.3314C8.07077 8.31565 8.14154 5.99982 8.12615 5.98406Z" fill="black"/>
							<path d="M14.6402 11.5071L13.8693 11.3811C13.8242 11.2264 13.7625 11.0777 13.6853 10.937L14.1353 10.2956C14.1717 10.2438 14.1654 10.1733 14.1207 10.1284L13.6134 9.62139C13.5681 9.57626 13.4969 9.57039 13.445 9.60783L12.8133 10.0619C12.6713 9.98335 12.5213 9.921 12.3657 9.87574L12.2312 9.108C12.2202 9.04565 12.1661 9 12.1027 9H11.3853C11.3214 9 11.2669 9.0463 11.2566 9.10943L11.1319 9.873C10.9753 9.918 10.8251 9.9797 10.6836 10.0572L10.0536 9.60717C10.0015 9.57 9.9307 9.576 9.88543 9.621L9.37843 10.128C9.3337 10.1727 9.32743 10.2432 9.36383 10.295L9.80717 10.9293C9.72826 11.0721 9.66539 11.2233 9.61961 11.3806L8.85904 11.5072C8.79617 11.5177 8.75 11.5722 8.75 11.6358V12.3532C8.75 12.4165 8.79539 12.4706 8.85761 12.4817L9.61817 12.6166C9.6637 12.7735 9.72656 12.9247 9.80574 13.0679L9.35691 13.6957C9.31987 13.7474 9.32574 13.8185 9.37074 13.8638L9.87787 14.3713C9.92261 14.416 9.99317 14.4223 10.045 14.3859L10.6802 13.941C10.8227 14.0194 10.9734 14.0816 11.1295 14.1267L11.2568 14.8912C11.2671 14.954 11.3215 15 11.3853 15H12.1027C12.166 15 12.2201 14.9546 12.231 14.8924L12.3673 14.1241C12.5237 14.0781 12.6736 14.0155 12.8147 13.937L13.4545 14.3858C13.5064 14.4224 13.5769 14.416 13.6217 14.3713L14.1289 13.8638C14.174 13.8185 14.1799 13.7472 14.1424 13.6953L13.6862 13.0617C13.7635 12.9209 13.825 12.7719 13.8697 12.6172L14.6416 12.4817C14.7041 12.4707 14.7495 12.4165 14.7495 12.3532V11.6358C14.7496 11.5719 14.7033 11.5174 14.6402 11.5071ZM11.7497 12.913C11.2455 12.913 10.8367 12.5043 10.8367 12C10.8367 11.4957 11.2455 11.087 11.7497 11.087C12.254 11.087 12.6628 11.4957 12.6628 12C12.6628 12.5043 12.254 12.913 11.7497 12.913Z" fill="black"/>
						</svg>
						</div>
						<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'course_management' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Manage Courses</div>
					</a>
				</div>
				<div v-if="sidebar.course_management && !isSidebarToggle" class="absolute z-50  rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white bg-tooltip">Manage Courses</div>
				</div>
			</li>
			<li @click="navigate('user_dashboard', 'user_dashboard')" class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5"  @mouseenter="sidebar.user_dashboard = true" @mouseleave="sidebar.user_dashboard = false" :class="selectedOptionName === 'user_dashboard' ? 'bg-primary text-white font-normal a svg-icon123' : 'text-black font-normal'">
				<div>
					<a class="flex navchild controlalign items-center hover:text-white py-1.5">
						<div class="py-0.5">
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M6.63077 2.01801C4.16308 2.45912 2.31385 2.80571 2.23385 2.84509C1.90462 3.00657 1.61231 3.48313 1.52 4.01876C1.45846 4.35747 1.46769 5.20031 1.53231 5.61778C1.59077 5.96831 1.76923 6.49607 1.90154 6.70087L1.97846 6.81902L1.65231 6.94505C1.29846 7.0829 1.23692 7.1341 1.24 7.29164C1.24 7.43736 1.34769 7.56733 1.55077 7.6658C1.79385 7.78789 1.96615 8.02814 2.04615 8.36685C2.12308 8.67799 2.15692 9.16636 2.12615 9.52082L2.10154 9.77288L1.69846 9.94224C1.21846 10.1392 1 10.2967 1 10.4424C1 10.5409 1.01231 10.5488 1.31385 10.6394L1.39692 10.6669L1.28 10.8875C1.21538 11.0135 1.12923 11.2183 1.08923 11.3483C1.02154 11.5649 1.01846 11.6397 1.01846 12.3132C1.01846 12.9355 1.02769 13.0851 1.08615 13.349C1.2 13.8807 1.40308 14.3021 1.64308 14.4991C1.74769 14.5857 7.49846 17 7.6 17C7.67385 17 16.1754 14.3573 16.24 14.3179C16.4215 14.1919 16.1538 13.9556 15.5262 13.6917L15.1692 13.542L15.1477 13.2506C15.1231 12.8843 15.1692 12.329 15.2431 12.073C15.3385 11.7539 15.4308 11.6318 15.7138 11.4546C16.0031 11.2734 16.0769 11.1632 16.0277 10.982C16.0062 10.8993 15.9631 10.8599 15.8246 10.8008L15.6492 10.7299L15.7877 10.5527C16.0646 10.1943 16.2431 9.54445 16.28 8.74888C16.3108 8.08721 16.2215 7.53976 16.0277 7.17348C15.9846 7.09078 15.9538 7.01988 15.96 7.01595C15.9662 7.01201 16.0738 6.97656 16.2 6.94111C16.3262 6.90567 16.5046 6.84659 16.5938 6.81508C16.7446 6.75994 16.7569 6.74813 16.7477 6.64967C16.7354 6.50788 16.4923 6.34247 16.0092 6.1416L15.6492 5.99194L15.6277 5.70049C15.5846 5.0979 15.6831 4.47169 15.8646 4.18811C15.9292 4.08965 16.04 3.99119 16.1815 3.90848C16.3015 3.83759 16.4246 3.73913 16.4585 3.6958C16.5262 3.59734 16.5323 3.42799 16.4708 3.34922C16.4062 3.26651 11.1446 1.24607 11.0062 1.25001C10.9446 1.25394 8.97538 1.59659 6.63077 2.01801ZM5.33231 4.8104C6.86462 5.45237 8.12308 5.98012 8.12615 5.98406C8.14154 5.99982 8.07077 8.31565 8.05846 8.3314C8.05231 8.34321 6.79077 7.89817 5.25231 7.35072C3.00308 6.54727 2.44 6.33065 2.35385 6.24794C2.12615 6.02345 2.00308 5.52326 2 4.7907C2 4.26295 2.05538 4.00301 2.21538 3.78639C2.29538 3.67611 2.33846 3.64854 2.43077 3.64854C2.49846 3.64854 3.68923 4.1251 5.33231 4.8104ZM15.3785 4.46381C15.2892 4.82221 15.2554 5.44055 15.2985 5.88166L15.3262 6.16523L14.6185 6.38579C14.2277 6.50788 12.6708 7.00019 11.16 7.48462L8.41231 8.36685L8.43385 7.35466C8.44615 6.79933 8.46462 6.26763 8.47385 6.16917L8.49231 5.99588L11.9538 5.08215C13.8585 4.57802 15.4246 4.16448 15.4338 4.16448C15.4462 4.16055 15.4215 4.29839 15.3785 4.46381ZM15.52 7.52795C15.7138 7.73669 15.8062 8.3314 15.7446 8.96943C15.6892 9.54445 15.5415 9.94618 15.3385 10.088C15.2492 10.151 9.71077 12.136 9.69538 12.1123C9.68 12.0927 9.61539 9.77682 9.62769 9.76107C9.63385 9.75713 10.8831 9.22937 12.4031 8.59134C14.1138 7.87847 15.2185 7.43342 15.2985 7.43342C15.3938 7.42949 15.4492 7.45706 15.52 7.52795ZM5.83077 8.86703C7.71692 9.36328 9.26769 9.77288 9.27385 9.78076C9.29231 9.79651 9.34461 12.0808 9.32615 12.1045C9.31692 12.1163 7.76308 11.6358 5.87692 11.0371L2.44308 9.94224L2.46462 9.44599C2.48615 8.90248 2.45231 8.51257 2.35385 8.15023C2.29846 7.94543 2.29846 7.93361 2.34769 7.94937C2.37846 7.96118 3.94769 8.37472 5.83077 8.86703ZM4.86154 12.3683L7.63077 13.5263L7.64 13.7153C7.65231 13.9871 7.6 15.8539 7.57846 15.8775C7.56923 15.8933 6.29538 15.4482 4.75077 14.8969L1.93846 13.8886L1.80923 13.7074C1.62154 13.4514 1.55077 13.1363 1.53231 12.5101C1.50462 11.6358 1.65231 11.2144 1.98462 11.2144C2.04308 11.2104 3.33846 11.7342 4.86154 12.3683ZM14.9538 11.7894C14.9415 11.8288 14.9046 11.9981 14.8708 12.1714C14.8185 12.4314 14.8123 12.5771 14.8185 13.1009L14.8308 13.7192L11.3938 14.8141C9.50154 15.4207 7.95077 15.9051 7.94154 15.8933C7.92308 15.8657 7.98769 13.5972 8.00923 13.5696C8.02154 13.5538 8.34769 13.4593 8.73231 13.3608C9.24615 13.2269 9.47077 13.1836 9.56615 13.1994C9.67077 13.223 9.78154 13.1915 10.1108 13.0576C10.3877 12.9473 11.2462 12.6992 12.7077 12.3132C13.9108 11.9942 14.9108 11.7303 14.9354 11.7264C14.9631 11.7224 14.9692 11.7461 14.9538 11.7894Z" fill="black"/>
						</svg>
						</div>
						<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'user_dashboard' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">My Courses</div>
					</a>
				</div>
				<div v-if="sidebar.user_dashboard && !isSidebarToggle" class="absolute z-50  rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white bg-tooltip">My Courses</div>
				</div>
			</li>
		</ul>
		<ul class="bottomUl">
			<li class="relative">
				<hr class="mb-4" />
				<img src="@/assets/leftArrowIcon.svg" class=" icon   arrowIcon leftarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-if="isSidebarToggle" />
				<img src="@/assets/rightArrowIcon.svg" class="arrowiconRight  icon  rightarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-else />
			</li>
				<li v-if="userInfo.currentRole == 10207" class="setting">
					<a @click="triggerNavToSettings()" class="flex navchild  py-1 pl-2.5">
					<img src="@/assets/settings.svg" class="h-5 icon" :class="{ 'pr-1.5': isSidebarToggle, '': !isSidebarToggle }" />
					<div class="item-name leading-5 text-black text-sm" v-if="isSidebarToggle">Settings</div>
				<!-- <a @click="triggerNavToSettings()" class="flex navchild py-1" :class="{ 'pl-1': isSidebarToggle, 'pl-2.5': !isSidebarToggle }">
					<img src="@/assets/settings.svg" class="icon" :class="{ 'px-1.5': isSidebarToggle, '': !isSidebarToggle }" />
					<div class="item-name leading-5 text-sm text-lightgrey" v-if="isSidebarToggle">Settings</div>
				</a> -->
					</a>
				</li>
		</ul>
	</div>
	<div class="fixed z-50 bg-white w-40 px-2 py-1 min-h-30 flex flex-col justify-center" v-if="appsVisible">
		<div class="flex flex-row items-center cursor-pointer">
			<!-- <div class="flex flex-col mr-1 w-2/4 items-center" @click="triggerNav('monitor')">
				<img src="@/assets/training.svg" alt="" class="icn h-6 w-6 ml-2" />
				<div class="nav-item-label-container">
					<div class="nav-item-label">Monitor</div>
				</div>
			</div> -->
			<div class="flex flex-row items-center cursor-pointer">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_4516_14738)">
				<path d="M0 0C7.92 0 15.84 0 24 0C24 7.92 24 15.84 24 24C16.08 24 8.16 24 0 24C0 16.08 0 8.16 0 0Z" fill="#FF9A00"/>
				<path d="M19.6399 17.0902V8.18107C19.6399 7.67475 19.4388 7.18916 19.0808 6.83114C18.7227 6.47311 18.2371 6.27198 17.7308 6.27198H17.0945C17.0944 5.97653 17.0258 5.68513 16.894 5.42071C16.7622 5.15629 16.5708 4.92607 16.3349 4.74817C16.099 4.57027 15.8251 4.44954 15.5346 4.3955C15.2441 4.34145 14.9451 4.35556 14.661 4.43671L12.7519 4.98271C12.4741 5.06217 12.2181 5.20408 12.0036 5.39762C11.789 5.20408 11.533 5.06217 11.2552 4.98271L9.3461 4.43671C9.06201 4.35556 8.76297 4.34145 8.4725 4.3955C8.18204 4.44954 7.90809 4.57027 7.6722 4.74817C7.43632 4.92607 7.24494 5.15629 7.11314 5.42071C6.98134 5.68513 6.9127 5.97653 6.91264 6.27198H6.27628C5.76996 6.27198 5.28437 6.47311 4.92635 6.83114C4.56832 7.18916 4.36719 7.67475 4.36719 8.18107V17.0902H11.3672V18.3629H8.82173V19.6356H15.1854V18.3629H12.6399V17.0902H19.6399ZM12.6399 6.81798C12.64 6.67977 12.685 6.54534 12.7683 6.43501C12.8515 6.32467 12.9684 6.24444 13.1013 6.20643L15.0104 5.66107C15.0673 5.6446 15.1261 5.63604 15.1854 5.63562C15.3541 5.63562 15.516 5.70266 15.6353 5.822C15.7547 5.94134 15.8217 6.1032 15.8217 6.27198V10.2467L12.6399 11.1554V6.81798ZM8.18537 6.27198C8.18551 6.17354 8.20849 6.07648 8.25249 5.98843C8.29649 5.90038 8.36032 5.82373 8.43896 5.76453C8.51759 5.70532 8.6089 5.66516 8.70568 5.64721C8.80246 5.62925 8.90209 5.634 8.99673 5.66107L10.9058 6.20643C11.0387 6.24444 11.1556 6.32467 11.2388 6.43501C11.3221 6.54534 11.3671 6.67977 11.3672 6.81798V11.1554L8.18537 10.2467V6.27198ZM5.63991 8.18107C5.63991 8.0123 5.70696 7.85043 5.8263 7.73109C5.94564 7.61175 6.1075 7.54471 6.27628 7.54471H6.91264V11.2063L12.0036 12.6611L17.0945 11.2063V7.54471H17.7308C17.8996 7.54471 18.0615 7.61175 18.1808 7.73109C18.3001 7.85043 18.3672 8.0123 18.3672 8.18107V15.8174H5.63991V8.18107Z" fill="white"/>
				</g>
				<defs>
				<clipPath id="clip0_4516_14738">
				<rect width="24" height="24" rx="4" fill="white"/>
				</clipPath>
				</defs>
				</svg>

				<div class="nav-item-label-container ml-2">
					<div class="text-sm font-semibold">Training</div>
					<div class="active-border"></div>
				</div>
			</div>
			<!-- <div class="flex flex-col w-2/4 items-center cursor-pointer" @click="triggerNav('workflow')">
				<img src="@/assets/training2.svg" alt="" class="icn h-8 w-8 ml-2" />
				<div class="nav-item-label-container">
					<div class="text-xs">Training</div>
					<div class="active-border"></div>
				</div>
			</div> -->
		</div>
	</div>
</template>
<style scoped>
.mainlogo{
	position:fixed;
	margin-left:9px;
	z-index:52;
}
.sideheight{
	height: 100%;
    z-index: 51;
	padding-top: 85px;
	border-right: 1px solid rgb(233,233,233);
}
.min-h-30{
    height: 50px;
}
.w-40{
    width: 170px;
}
.setting{
    height: 35px;
    margin-top: 5px;
}
.bottomUl{
    height: 51px;
}
.icon:hover {
transition: none !important;
}
.svg{
	fill: black;
}
.shadow {
	--tw-shadow:5px 5px 5px 0px rgba(0, 0, 0, 0.25);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.leftarrow,
.rightarrow {
	/* height: 1.25rem; */
	/* width: 1.25rem; */
	margin-top: -27px;
}

.a:hover{
	color:white;
	 font-weight: bold; 
	 } 
.controlalign{
	padding-top:6px;
	padding-bottom: 6px;
}
.svg-icon:hover {
    color:white;
}
.svg-icon123 div a svg path,
.svg-icon123 div a svg rect,
.svg-icon:hover path,
.svg-Image:hover svg path,
.svg-Image:hover svg rect,
.svg-icon:hover rect
 {
    fill: white;
}
.tooltipwidth {
	width: auto;
}
.bg-tooltip{
	background-color: #1976d2;
	border-radius:3px;
}
.transform-y-top{
	transform: translateY(-26px);
}
.arrowIcon{
	height:22px;
	width:22px;
	margin-left:156px;
}
.arrowiconRight{
	height:22px;
	width:22px;
	margin-left:29px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { emitter } from '../main';
import { mapGetters } from 'vuex';
export default defineComponent({
	data() {
		return {
			resizeTimeout:0,
			isSidebarToggle: true,
			appsVisible: false,
			isActive: false,
			dashboard: false,
			hover:false,
			show:false,
			courseManagement: false,
			courses: false,
			selectedOptionName: '',
			passingRouteName:'',
			sidebar: { dashboard: false, course_management: false, user_dashboard: false, mydocuments: false },
			menus: [
				{
					optionName: 'dashboard',
					optionRoute: 'dashboard',
					defaultoptionImage: require('@/assets/dashboardDefault.svg'),
					colouredoptionImage: require('@/assets/dashboardColoured.svg'),
					displayOptionName: 'Dashboard',
					userRole:10207,
				},
				{
					optionName: 'course_management',
					defaultoptionImage: require('@/assets/coursemanagementDefault.svg'),
					colouredoptionImage: require('@/assets/coursemanagementColoured.svg'),
					optionRoute: 'course_management',
					displayOptionName: 'Manage Courses',
					userRole:10207,
					
				},
				{
					optionName: 'user_dashboard',
					defaultoptionImage: require('@/assets/coursesDefault.svg'),
					colouredoptionImage: require('@/assets/coursesColoured.svg'),
					optionRoute: 'user_dashboard',
					displayOptionName: 'My Courses',
				
					
					
				}
			]
		};
	},

	computed: {
		...mapGetters({ userInfo: 'userInfo',toggleState:'toggle' }),
		currentRouteName() {
            return this.$route.name;
        },
	},
	mounted() {
		window.addEventListener('resize', this.debouncedHandleResize);
		if(this.$route.path.includes('dashboard')){
            this.passingRouteName = 'dashboard';
        }else if(this.$route.path.includes('manage')){
            this.passingRouteName = 'course_management'
        }else if(this.$route.path.includes('courses')||this.$route.path.includes('course')){
            this.passingRouteName = 'user_dashboard'
        }
        this.selectedOptionName = this.passingRouteName;
		console.log("logged")
		emitter.on('toggle-sidebar', (isToggle: any) => {
			this.isSidebarToggle = isToggle;
		});
		emitter.on('apps-sidemenubar', (isToggle: any) => {
			this.appsVisible = isToggle;
		});
		emitter.on('apps', (isToggle: any) => {
			this.appsVisible = isToggle;
		});
		this.isSidebarToggle=this.toggleState
	},
	methods: {
		navigate(name:any, routerOption:any) {	
			this.$store.dispatch('selectedToggle',this.isSidebarToggle);
			this.$store.dispatch('selectedRoute', name);
			this.$router.push({ name: routerOption });
		},
		triggerNavToSettings() {
			window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_ORG_WEBAPP_URL}`;
		},
		// triggerNav() {
		// 	window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_MONITOR_WEBAPP_URL}`;
		// },
		triggerNav(app:string) {
			window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${app == 'monitor' ? process.env.VUE_APP_MONITOR_WEBAPP_URL : process.env.VUE_APP_WORKFLOW_WEBAPP_URL}`;
		},
		triggerNavToAdminSettings() {
			window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_ADMIN_WEBAPP_URL}`;
		},
		toggleSideMenuBar() {
			this.isSidebarToggle = !this.isSidebarToggle;
			emitter.emit('toggle-sidebar', this.isSidebarToggle);
		},
		 debouncedHandleResize() {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.handleResize, 100); // Adjust debounce time as needed
        },
        handleResize() {
            // if(window.innerWidth<720)
            // {
			// 	this.$store.dispatch('selectedToggle', false);
			// 	this.isSidebarToggle = false;
			// 	emitter.emit('toggle-sidebar', this.isSidebarToggle);
            //     // console.log("hii checking reponsive or not");
            // }
			// else{
			// 	this.$store.dispatch('selectedToggle', true);
			// 	this.isSidebarToggle = true;
			// 	emitter.emit('toggle-sidebar', this.isSidebarToggle);
			// 	// console.log("big screen");
			// }

			if(window.innerWidth<1164)
            {
                this.$store.dispatch('selectedToggle', false);
                this.isSidebarToggle = false;
                emitter.emit('toggle-sidebar', this.isSidebarToggle);
            }
            else if(this.isSidebarToggle == false){
                this.$store.dispatch('selectedToggle', true);
                this.isSidebarToggle = true;
                emitter.emit('toggle-sidebar', this.isSidebarToggle);
            }
        },
		
	},
	 beforeUnmount() {
        window.removeEventListener('resize', this.debouncedHandleResize);
    },
});
</script>
